import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

/**
 * 전역적으로 사용되는 삭제 확인 모달.
 */
const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, title = "질의 기록 삭제" }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm animate-in fade-in duration-300"
                onClick={onClose}
            ></div>

            {/* Modal Content */}
            <div className="relative bg-white w-full max-w-[340px] sm:max-w-[360px] rounded-[32px] shadow-2xl border border-white/20 p-6 sm:p-8 animate-in zoom-in-95 duration-200">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 sm:top-6 sm:right-6 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all"
                >
                    <X size={18} className="sm:size-5" />
                </button>

                <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center mb-6 shadow-sm border border-red-100">
                        <AlertTriangle size={32} className="text-red-500" />
                    </div>

                    <h3 className="text-xl font-black text-gray-900 mb-2">{title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed mb-8">
                        이 질의 기록을 삭제하시겠습니까?<br />
                        <span className="text-red-500 font-medium">삭제된 데이터는 복구할 수 없습니다.</span>
                    </p>

                    <div className="flex flex-col w-full gap-3">
                        <button
                            onClick={onConfirm}
                            className="w-full h-12 bg-red-500 text-white font-bold rounded-2xl shadow-lg shadow-red-200 hover:bg-red-600 active:scale-[0.98] transition-all"
                        >
                            삭제하기
                        </button>
                        <button
                            onClick={onClose}
                            className="w-full h-12 bg-gray-50 text-gray-600 font-bold rounded-2xl hover:bg-gray-100 active:scale-[0.98] transition-all"
                        >
                            취소
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
